module.exports = __webpack_public_path__ + "static/media/ajax-Loader.3c71b2ee.gif";